// if (document.body.id === "Home") {
// 	/** @type {HTMLElement} */
// 	let newsSlider = document.querySelector("section#news .articles");
// 	let prev = document.querySelector("section#news .controls .prev");
// 	let next = document.querySelector("section#news .controls .next");

// 	addEventListener("resize", () => {
// 		prev.classList.toggle("inactive", newsSlider.scrollLeft === 0);
// 		next.classList.toggle("inactive", newsSlider.scrollLeft === newsSlider.scrollWidth - newsSlider.clientWidth);
// 	});

// 	newsSlider.addEventListener("scroll", () => {
// 		prev.classList.toggle("inactive", newsSlider.scrollLeft === 0);
// 		next.classList.toggle("inactive", newsSlider.scrollLeft === newsSlider.scrollWidth - newsSlider.clientWidth);
// 	});

// 	prev.addEventListener("click", () => {
// 		let articleWidth = newsSlider.children[0].clientWidth + 16;
// 		newsSlider.scrollTo({ left: (Math.ceil((newsSlider.scrollLeft - Math.max((innerHeight - 1066) / 2, 50)) / articleWidth) - 1) * articleWidth, behavior: "smooth" });
// 	});

// 	next.addEventListener("click", () => {
// 		let articleWidth = newsSlider.children[0].clientWidth + 16;
// 		newsSlider.scrollTo({ left: (Math.floor((newsSlider.scrollLeft + Math.max((innerHeight - 1066) / 2, 50)) / articleWidth) + 1) * articleWidth, behavior: "smooth" });
// 	});
// }

if (document.body.id === "News") {
	document.getElementById("load-more")?.addEventListener("click", () => {
		let offset = document.querySelectorAll("#articles .article").length;

		fetch(`/news/load_more?offset=${encodeURIComponent(offset)}`)
		.then(res => res.json())
		.then(content => {
			let temp = document.createElement("span");

			for (let html of content.elements) {
				temp.innerHTML = html;

				document.getElementById("articles").append(...temp.childNodes, document.createElement("hr"));
			}

			if (content.finished) document.getElementById("load-more--wrapper").remove();
		});
	});
}